var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "box mdc-typography",
      class: { "mdc-elevation--z3": _vm.showInCard }
    },
    [
      _vm.showInCard ? _c("header", { staticClass: "box__header" }) : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box__content" },
        [
          _c("div", { staticClass: "box__content__title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _vm._t("content")
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "box__button-panel" }, [_vm._t("buttons")], 2),
      _vm._v(" "),
      _vm._t("usp")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }